/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  function uspMob () {

    if(window.matchMedia("(max-width: 767px)").matches) {
      
      var elem = document.querySelector('.usp-bar-mobile');
      var flkty = new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true
      });

      // element argument can be a selector string
      //   for an individual element
      var flkty = new Flickity( '.usp-bar-mobile', {
        // options
      });

    }

  }

  function accordionTech () {

    document.addEventListener('click', function (event) {

      // If the clicked element doesn't have the right selector, bail
      if (!event.target.matches('.accordion')) return;
    
      // Don't follow the link
      event.preventDefault();
    
      // Log the clicked element in the console
      console.log(event.target);
    
    }, false);
    
  }


  function uspSlider() {
    if (window.mobileCheck()) {
      $(".usp-bar__list").flickity({
        cellAlign: "left",
        cellSelector: ".usp__slider-item",
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        autoPlay: true,
        wrapAround: true,
        draggable: true
      });
    }
  }

  // function homepageSlider() {

  //     $(".homepage-slideshow").flickity({
  //       cellAlign: "left",
  //       cellSelector: ".slideshow__slide",
  //       contain: true,
  //       prevNextButtons: false,
  //       pageDots: true,
  //       autoPlay: true,
  //       wrapAround: true,
  //       draggable: true
  //     });

  // }

  accordionTech();
  uspMob();

  // homepageSlider();


  function addtocartBorder() {

    //bit of a hack, did this to get the tooltip to work on the quick add to cart button
    $('.product__submit__quick').hover(function() {
        if($('.tooltip_new').prop('disabled')) {
          $('.tooltip_new').toggleClass('hover');
        }
    });

    $('.product__submit__add').click(function() {
      $('.ddm_select_box').addClass('ddm_select_box--active');
    });

    $('.shopify-payment-button').click(function() {
      $('.ddm_select_box').addClass('ddm_select_box--active');
    });

    $('.product__submit__buttons').click(function() {
      $('.ddm_select_box').addClass('ddm_select_box--active');
    });

    $('#dds_calendar').click(function(e) {
      console.log('datepickerworks');
      $('.ddm_select_box').removeClass('.ddm_select_box--active');
    });

     
  
  }
  
  addtocartBorder();
  

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
